import { PRICE_SCENARIOS } from "@circle-react/helpers/paywallPriceHelpers";

import { t } from "@/i18n-js/instance";

import { DefaultFullPreview } from "../../..";
import type { ComponentLineProps } from "../types";

export const FreeTrialLine = ({ preview, options }: ComponentLineProps) => {
  if (
    ![
      PRICE_SCENARIOS.trialThenValue,
      PRICE_SCENARIOS.trialThenUpfrontThenValue,
    ].includes(preview.preview_scenario)
  ) {
    return null;
  }

  return (
    <DefaultFullPreview.PreviewEntry
      label={t("paywall_checkout.free_trial_day", {
        count: preview?.trial_period?.days,
      })}
      value={preview.formatted_amount_due_now}
      valueWeight="semibold"
      dataTestId="checkout-form-preview-today-payment-free-trial"
      {...options}
    />
  );
};
